module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Image-6b6817537ea20a26e0f0e21833f16603.svg";